import { Controller } from "@hotwired/stimulus"

// Wypełnia pola klienta danymi z CRM po wybraniu klienta z intum_select
export default class extends Controller {
  static targets = [
    "clientName", "clientEmail", "clientPhone", "clientTaxNo",
    "clientStreet", "clientPostCode", "clientCity",
    "clientFirstName", "clientLastName",
  ]

  static values = { clientDataUrl: String }

  // Nasłuchuje na zmianę intum_select (change event na komponencie)
  clientChanged() {
    const hiddenField = this.element.querySelector("input[name='order[client_id]']")
    if (!hiddenField) return

    const clientId = hiddenField.value
    if (!clientId || clientId === "") return

    this.fetchClientData(clientId)
  }

  async fetchClientData(clientId) {
    const url = `${this.clientDataUrlValue}?client_id=${clientId}`
    const response = await fetch(url, {
      headers: { Accept: "application/json", "X-CSRF-Token": this.csrfToken() },
    })
    if (!response.ok) return

    const data = await response.json()
    this.fillFields(data)
  }

  fillFields(data) {
    if (this.hasClientNameTarget) this.clientNameTarget.value = data.name || ""
    if (this.hasClientEmailTarget) this.clientEmailTarget.value = data.email || ""
    if (this.hasClientPhoneTarget) this.clientPhoneTarget.value = data.phone || ""
    if (this.hasClientTaxNoTarget) this.clientTaxNoTarget.value = data.tax_no || ""
    if (this.hasClientStreetTarget) this.clientStreetTarget.value = data.street || ""
    if (this.hasClientPostCodeTarget) this.clientPostCodeTarget.value = data.post_code || ""
    if (this.hasClientCityTarget) this.clientCityTarget.value = data.city || ""
    if (this.hasClientFirstNameTarget) this.clientFirstNameTarget.value = data.first_name || ""
    if (this.hasClientLastNameTarget) this.clientLastNameTarget.value = data.last_name || ""
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
